import React from "react";

import PropTypes from "prop-types";
import Helmet from "react-helmet";
import { StaticQuery, graphql } from "gatsby";
import SiteHeader from "../common/SiteHeader";
import SiteFooter from "../common/SiteFooter";
import SiteFooterCta from "../common/SiteFooterCta";
import HomePage from "../../pages/home";

// Styles
import "../../styles/app.scss";
import "../../styles/mixins.scss";
import "../../styles/variables.scss";
import "../../styles/typography.scss";
import "../../styles/button.scss";

/**
 * Main layout component
 *
 * The Layout component wraps around each page and template.
 * It also provides the header, footer as well as the main
 * styles, and meta data for each page.
 *
 */
const DefaultLayout = ({
    data,
    children,
    bodyClass,
    isHome,
    headerVariant,
    siteFooterCta = <SiteFooterCta />
}) => {
    const site = data.allGhostSettings.edges[0].node;

    return (
        <>
            <Helmet>
                <html lang={site.lang} />
                <link
                    href="https://fast.fonts.net"
                    rel="preconnect"
                    crossorigin
                />
                <script
                    type="text/javascript"
                    src="//fast.fonts.net/jsapi/5407265f-b6de-432e-afd8-f0ca2b5f0d60.js"
                />
                <body className={bodyClass} />
            </Helmet>

            <div className="viewport">
                <div className="viewport-top">
                    {/* The main header section on top of the screen */}
                    <SiteHeader
                        variant={isHome ? `light-on-dark` : headerVariant}
                    />

                    {isHome ? <HomePage /> : null}

                    <main className="site-main">
                        {/* All the main content gets inserted here, index.js, post.js */}
                        {children}
                    </main>
                </div>
                <div className="viewport-bottom">
                    {/* The footer at the very bottom of the screen */}
                    {siteFooterCta}
                    <SiteFooter />
                </div>
            </div>
        </>
    );
};

DefaultLayout.propTypes = {
    children: PropTypes.node.isRequired,
    bodyClass: PropTypes.string,
    isHome: PropTypes.bool,
    data: PropTypes.shape({
        allGhostSettings: PropTypes.object.isRequired
    }).isRequired
};

const DefaultLayoutSettingsQuery = props => (
    <StaticQuery
        query={graphql`
            query GhostSettings {
                allGhostSettings {
                    edges {
                        node {
                            ...GhostSettingsFields
                        }
                    }
                }
            }
        `}
        render={data => <DefaultLayout data={data} {...props} />}
    />
);

export default DefaultLayoutSettingsQuery;
